import { yup } from '@guiker/yup-util'

export const userIdPathParamsSchema = yup.object({
  userId: yup.string(),
})

export type UserIdPathParamsSchema = yup.InferType<typeof userIdPathParamsSchema>
